import UserManagement from "../components/management/users/UserManagement";
import styles from "../styles/pages/Management.module.scss";

import { useState } from "react";

type Pages = "users"

export default function Management({}){
    const [selectedPage, setselectedPage] = useState<Pages>("users");

    return (
        <>     
            {selectedPage === "users" && 
                <UserManagement />
            }
        </>
    )
}